import * as React from "react";

// Components
import IconClose from "../Icons/IconClose";

// Styles
import "./MoreInfoContent.scss";

interface MoreInfoContent {
  text: string;
  closeFunc: () => void;
}

const MoreInfoContent: React.FC<MoreInfoContent> = (props: MoreInfoContent) => {
  const { text, closeFunc } = props;

  return (
    <div className="moreInfoContent text-left text-s bg-dw-grey-02 relative">
      <IconClose className="absolute cursor-pointer" onClick={closeFunc} />
      <p className="text-dw-grey-12">{text}</p>
    </div>
  );
};

export default MoreInfoContent;
